import { createApp } from 'vue';
import { createPinia } from 'pinia';
import { store } from './modules/zelos/stores';
import App from './App.vue';
import router from './routes';

import { registerSW } from 'virtual:pwa-register';
import { useAuthStore } from '@/modules/auth/stores/authStore';

import 'bootstrap';

import { library } from '@fortawesome/fontawesome-svg-core';

import { faWindows } from '@fortawesome/free-brands-svg-icons';

import {
  faArrowRightFromBracket,
  faArrowRightToBracket,
  faBars,
  faCircleCheck,
  faCircleInfo,
  faDesktop,
  faEnvelope,
  faFileContract,
  faFileDownload,
  faFileExport,
  faFileImport,
  faFloppyDisk,
  faHeadset,
  faHome,
  faMagnifyingGlassPlus,
  faMinus,
  faPaperPlane,
  faPen,
  faPlus,
  faPrint,
  faRectangleList,
  faRotate,
  faServer,
  faShieldHalved,
  faXmark,
} from '@fortawesome/free-solid-svg-icons';

library.add(
  faArrowRightFromBracket,
  faArrowRightToBracket,
  faBars,
  faCircleCheck,
  faCircleInfo,
  faDesktop,
  faEnvelope,
  faFileContract,
  faFileDownload,
  faFileExport,
  faFileImport,
  faFloppyDisk,
  faHeadset,
  faHome,
  faMagnifyingGlassPlus,
  faMinus,
  faPaperPlane,
  faPen,
  faPlus,
  faPrint,
  faRectangleList,
  faRotate,
  faServer,
  faShieldHalved,
  faWindows,
  faXmark
);

import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

registerSW({ immediate: true });

async function bootstrap() {
  const app = createApp(App);
  app.use(createPinia());

  app.use(store); // Vuex Store einbinden, solange Vuex noch verwendet wird

  app.use(router);
  app.component('font-awesome-icon', FontAwesomeIcon);

  const auth = useAuthStore();
  await auth.initAuth();

  if (!auth.isAuthenticated) {
    auth.login();
  }

  app.mount('#app');
}

bootstrap();
